module.exports = __webpack_public_path__ + "img/mezzo2.6e8f059a.png";